(() => {
  if (customElements.get('mms-oil-picker')) return;
  customElements.define('mms-oil-picker', class extends HTMLElement {
    connectedCallback() {
      this.select = document.getElementById(this.dataset.select);
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.select || !this.details || !this.summary) return;
      this.label = this.summary.getAttribute('aria-label') || 'Choose a scent';
      this.sync = () => {
        const selected = this.querySelector(`[data-oil-value="${CSS.escape(this.select.value)}"]`);
        this.summary.replaceChildren();
        if (selected) [...selected.childNodes].forEach(node => this.summary.append(node.cloneNode(true)));
        else this.summary.textContent = 'Choose a scent';
        const stockText = selected?.querySelector('.mms-oil-choice-stock')?.textContent.trim();
        this.summary.setAttribute('aria-label', this.label + (selected ? ': ' + selected.querySelector('strong').textContent : '') + (stockText ? ', ' + stockText : '')); 
        this.querySelectorAll('[data-oil-value]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.oilValue === this.select.value));
          button.disabled = !!this.select.querySelector(`option[value="${CSS.escape(button.dataset.oilValue)}"]`)?.disabled;
        });
      };
      this.choose = event => {
        const button = event.target.closest('[data-oil-value]');
        if (!button || button.disabled) return;
        this.select.value = button.dataset.oilValue;
        this.select.dispatchEvent(new Event('change', {bubbles: true}));
        this.details.open = false;
        this.summary.focus();
      };
      this.keys = event => {
        if (event.key === 'Escape') { this.details.open = false; this.summary.focus(); }
      };
      this.invalid = event => { event.preventDefault(); this.details.open = true; this.summary.focus(); };
      this.addEventListener('click', this.choose);
      this.addEventListener('keydown', this.keys);
      this.select.addEventListener('change', this.sync);
      this.select.addEventListener('invalid', this.invalid);
      this.sync();
      this.hidden = false;
      const fallback = this.select.closest('.mms-oil-fallback');
      if (fallback) fallback.hidden = true;
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.choose);
      this.removeEventListener('keydown', this.keys);
      this.select?.removeEventListener('change', this.sync);
      this.select?.removeEventListener('invalid', this.invalid);
    }
  });
  document.querySelectorAll('.mms-emp-oil-picker').forEach(picker => {
    const sync = () => picker.querySelectorAll('.fudge-emp-scent-chip').forEach(button => button.setAttribute('aria-pressed', String(button.classList.contains('is-selected'))));
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(picker, {subtree: true, attributes: true, attributeFilter: ['class']});
    picker.addEventListener('keydown', event => { if(event.key === 'Escape') {picker.open = false; picker.querySelector('summary').focus();} });
  });
})();

